<template>
  <v-snackbar v-model="snackP" :timeout="snackTime" >
    {{snackText}}
    <!-- <v-btn flat color="primary" @click.native="value = false">Close</v-btn> -->
  </v-snackbar>
</template>

<script>
  export default {
    name: 'cardLoading',
    props: {
      snackP: {
        type: Boolean,
        default: () => false
      },
      snackText: {
        type: String,
        default: () => 'texto'
      },
      snackTime: {
        type: Number,
        default: () => 3000
      },
    },
    data() {
      return {
        snack: true
      }
    },
  }
</script>

<style scoped>


</style>